import { type RouteRecordRaw } from 'vue-router'

import { ORDER_PREFIX } from '../public/useOrderRouter'

export const ordersRouter: RouteRecordRaw[] = [
  {
    component: async () => import('../views/OrdersMainView.vue'),
    meta: {
      permissions: [{ operation: 'read', resource: 'order' }],
      scopes: ['orders:read'],
      title: 'restaurant.orders',
    },
    name: ORDER_PREFIX,
    path: 'orders',
  },
  {
    component: async () => import('../views/OrdersDetailView.vue'),
    meta: {
      permissions: [{ operation: 'read', resource: 'order' }],
      scopes: ['orders:read'],
    },
    name: `${ORDER_PREFIX}.detail`,
    path: 'orders/:orderId',
    props: true,
  },
]
